import {Map} from 'immutable';

export const LANGUAGES = {
  ar: {
    title: 'Arabic',
    name: 'ar',
    locale: 'ar_AR',
    host: 'google.ae',
    countries: [
      'dz',
      'bh',
      'td',
      'km',
      'dj',
      'eg',
      'er',
      'iq',
      'il',
      'jo',
      'kw',
      'lb',
      'ly',
      'mr',
      'ma',
      'om',
      'pk',
      'qa',
      'sa',
      'so',
      'sd',
      'sy',
      'tz',
      'tn',
      'ae',
      'ye'
    ]
  },
  bg: {
    title: 'Bulgarian',
    name: 'bg',
    locale: 'bg_BG',
    countries: ['bg']
  },
  ca: {
    title: 'Catalan',
    name: 'ca',
    locale: 'ca_CA',
    host: 'google.cat',
    coutries: ['es', 'fr', 'ad', 'it']
  },
  cs: {
    title: 'Czech',
    name: 'cs',
    locale: 'cs_CS',
    host: 'google.cz',
    countries: ['cz']
  },
  da: {
    title: 'Danish',
    name: 'da',
    locale: 'da_DA',
    host: 'google.dk',
    countries: ['dk']
  },
  de: {
    title: 'German',
    name: 'de',
    locale: 'de_DE',
    host: 'google.de',
    countries: ['de', 'be', 'at', 'ch', 'lu', 'li']
  },
  el: {
    title: 'Greek',
    name: 'el',
    locale: 'el_EL',
    host: 'google.gr',
    countries: ['gr', 'cy', 'al']
  },
  hi: {
    title: 'Hindi',
    name: 'hi',
    locale: 'hi_IN',
    host: 'google.co.in',
    countries: ['in', 'bd']
  },
  en: {
    title: 'English',
    name: 'en',
    locale: 'google.com',
    countries: [
      'us',
      'uk',
      'ru',
      'ca',
      'ie',
      'au',
      'nz',
      'mt',
      'hk',
      'in',
      'sg',
      'bd',
      'ph',
      'pk',
      'my',
      'bn',
      'jm'
    ]
  },
  es: {
    title: 'Spanish',
    name: 'es',
    locale: 'es_ES',
    host: 'google.es',
    countries: [
      'es',
      'br',
      'ad',
      'gi',
      'gq',
      'ma',
      'eh',
      'ga',
      'bz',
      'cr',
      'cu',
      'do',
      'sv',
      'gt',
      'hn',
      'mx',
      'ni',
      'us'
    ]
  },
  et: {
    title: 'Estonian',
    name: 'et',
    locale: 'et_ET',
    host: 'google.ee',
    countries: ['ee']
  },
  fi: {
    title: 'Finnish',
    name: 'fi',
    host: 'google.fi',
    countries: ['fi']
  },
  fr: {
    title: 'French',
    name: 'fr',
    locale: 'fr_FR',
    host: 'google.fr',
    countries: [
      'fr',
      'be',
      'it',
      'lu',
      'mc',
      'ch',
      'dz',
      'bj',
      'bf',
      'bi',
      'cm',
      'cf',
      'td',
      'km',
      'cg',
      'dj',
      'gq',
      'ga',
      'gn',
      'mg',
      'ml',
      'mr',
      'mu',
      'ma',
      'ne',
      're',
      'rw',
      'sn',
      'sc',
      'tg',
      'tn',
      'lb',
      'in',
      'ca',
      'gp',
      'ht',
      'mq',
      'pf',
      'nc',
      'vu',
      'wf',
      'gf'
    ]
  },
  hr: {
    title: 'Croatian',
    name: 'hr',
    locale: 'hr_HR',
    host: 'google.hr',
    countries: [
      'ba',
      'at',
      'hr',
      'it',
      'cs',
      'ro',
      'rs'
    ]
  },
  hu: {
    title: 'Hungarian',
    name: 'hu',
    locale: 'hu_HU',
    host: 'google.hu',
    countries: ['hu']
  },
  id: {
    title: 'Indonesian',
    name: 'id',
    locale: 'id_ID',
    host: 'google.co.id',
    countries: ['id', 'tl']
  },
  is: {
    title: 'Icelandic',
    name: 'is',
    locale: 'is_IS',
    host: 'google.is',
    countries: ['is']
  },
  it: {
    title: 'Italian',
    name: 'it',
    locale: 'it_IT',
    host: 'google.it',
    countries: [
      'it',
      'hr',
      'al',
      'sm',
      'va',
      'er'
    ]
  },
  iw: {
    title: 'Hebrew',
    name: 'iw',
    locale: 'iw_IW',
    host: 'google.co.il',
    countries: ['il']
  },
  ja: {
    title: 'Japanese',
    name: 'ja',
    locale: 'ja_JA',
    host: 'google.co.jp',
    countries: ['jp', 'pw']
  },
  ko: {
    title: 'Korean',
    name: 'ko',
    locale: 'ko_KO',
    host: 'google.co.kr',
    countries: ['kp', 'kr']
  },
  lt: {
    title: 'Lithuanian',
    name: 'lt',
    locale: 'lt_LT',
    host: 'google.lt',
    countries: ['lv', 'lt']
  },
  nl: {
    title: 'Dutch',
    name: 'nl',
    locale: 'nl_NL',
    host: 'google.nl',
    countries: [
      'nl',
      'be'
    ]
  },
  no: {
    title: 'Norwegian',
    name: 'no',
    locale: 'no_NO',
    host: 'google.no',
    countries: ['no']
  },
  pl: {
    title: 'Polish',
    name: 'pl',
    locale: 'pl_PL',
    host: 'google.pl',
    countries: ['pl']
  },
  pt: {
    title: 'Portuguese',
    name: 'pt',
    locale: 'pt_PT',
    host: 'google.pt',
    countries: ['pt']
  },
  ro: {
    title: 'Romanian',
    name: 'ro',
    locale: 'ro_RO',
    host: 'google.ro',
    countries: ['ro', 'md']
  },
  ru: {
    title: 'Russian',
    name: 'ru',
    locale: 'ru_RU',
    host: 'google.ru',
    countries: [
      'ru',
      'ua',
      'by',
      'kz',
      'ee',
      'lv',
      'lt',
      'pl',
      'il',
      'de',
      'rs',
      'gs',
      'az',
      'am',
      'kg',
      'uz',
      'tj',
      'tm',
      'md',
      'us',
      'ca',
      'au'
    ]
  },
  sk: {
    title: 'Slovak',
    name: 'sk',
    locale: 'sk_SK',
    host: 'google.sk',
    countries: ['sk']
  },
  sl: {
    title: 'Slovenian',
    name: 'sl',
    locale: 'sl_SL',
    host: 'google.si',
    countries: ['si', 'it']
  },
  sr: {
    title: 'Serbian',
    name: 'sr',
    locale: 'sr_SR',
    host: 'google.sr',
    countries: ['rs']
  },
  sv: {
    title: 'Swedish',
    name: 'sv',
    locale: 'sv_SV',
    host: 'google.se',
    countries: ['se']
  },
  tr: {
    title: 'Turkish',
    name: 'tr',
    locale: 'tr_TR',
    host: 'google.com.tr',
    countries: ['tr', 'cy']
  },
  ua: {
    title: 'Ukrainian',
    name: 'ua',
    locale: 'uk_UA',
    host: 'google.com.ua',
    countries: ['ua']
  },
  'zh-CN': {
    title: 'Chinese',
    country: 'China',
    name: 'zh-CN',
    locale: 'zh_ZH-CN',
    host: 'google.com.hk',
    countries: ['cn', 'hk', 'mo']
  }
};

export const languagesMap = Map(LANGUAGES);



// WEBPACK FOOTER //
// ./src/common/constants/languages.js